import { panelDelete, panelGet, panelPost, panelPut } from "./panel.api";
import { Settings, SettingsPayload } from "./types";

/** settings — /settings (emergency approach toggle + contract limit) */
export const settingsApi = {
  getAll: () => panelGet<Settings[]>("/settings"),
  getById: (id: string) => panelGet<Settings>(`/settings/${id}`),
  create: (payload: SettingsPayload) => panelPost<Settings>("/settings", payload),
  update: (id: string, payload: SettingsPayload) => panelPut<Settings>(`/settings/${id}`, payload),
  remove: (id: string) => panelDelete(`/settings/${id}`),
};
